export default __webpack_public_path__ + "static/media/g1627.af41776e.svg";